(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cherubina-passport"]) return;
  try {
    
  (() => {
    // Remember a manual language choice so the layout does not redirect it back
    document.querySelectorAll('[data-cp-lang]').forEach((link) => {
      link.addEventListener('click', () => {
        try {
          localStorage.setItem('cp-lang', link.dataset.cpLang);
        } catch (error) {}
      });
    });

    const intro = document.getElementById('cp-intro');
    const page = document.getElementById('cp-page');
    if (!intro || !page) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let closingTimer, hidingTimer;

    const complete = () => {
      clearTimeout(closingTimer);
      intro.classList.add('is-leaving');
      document.body.classList.remove('cp-intro-active');
      page.removeAttribute('inert');
      hidingTimer = setTimeout(() => {
        intro.hidden = true;
        intro.classList.remove('is-playing', 'is-leaving');
      }, 850);
    };
    const start = () => {
      clearTimeout(closingTimer);
      clearTimeout(hidingTimer);
      intro.hidden = false;
      intro.classList.remove('is-playing', 'is-leaving');
      void intro.offsetWidth;
      page.setAttribute('inert', '');
      document.body.classList.add('cp-intro-active');
      intro.classList.add('is-playing');
      closingTimer = setTimeout(complete, reduceMotion ? 2550 : 4400);
    };

    document.getElementById('cp-skip').addEventListener('click', complete);
    document.getElementById('cp-replay').addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'instant' });
      start();
    });
    // Theme editor: skip the opening so the page stays editable after each reload
    if (!intro.hasAttribute('data-cp-editor')) start();

    // Default poem only: shrink font so each verse stays on one line on small screens
    const poem = document.querySelector('[data-cp-fit]');
    if (!poem) return;
    const lines = Array.from(poem.querySelectorAll('.cp-verses__line'));
    const fit = () => {
      poem.style.removeProperty('font-size');
      if (window.innerWidth > 650) return;
      const available = poem.clientWidth;
      if (!available) return;
      const base = parseFloat(getComputedStyle(poem).fontSize);
      const widest = Math.max(...lines.map((line) => line.scrollWidth));
      if (widest > available - 3) {
        poem.style.fontSize = Math.max(9, (base * (available - 5)) / widest).toFixed(2) + 'px';
      }
    };
    fit();
    window.addEventListener('resize', fit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-wrapper]').forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    const playButton = wrapper.querySelector('[data-play-button]');

    if (!video || !playButton) return;

    // Initially, if video is not playing, show button.
    // However, if autoplay is off, we are showing poster + button.

    // Play button click
    playButton.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent bubbling to wrapper click if any
      e.preventDefault();
      video.play();
      playButton.classList.add('hero__play-button--hidden');
    });

    // Video click to pause
    video.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (!video.paused) {
        video.pause();
        playButton.classList.remove('hero__play-button--hidden');
      } else {
        video.play();
        playButton.classList.add('hero__play-button--hidden');
      }
    });

    // Ensure button state syncs if video ends or pauses by other means
    video.addEventListener('pause', () => {
      playButton.classList.remove('hero__play-button--hidden');
    });

    video.addEventListener('play', () => {
      playButton.classList.add('hero__play-button--hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
